import { DistributeReq, DistributeDef } from "../type/distribute-def";

export class DistributeAdapter {
  static toInputDTO(req: DistributeReq): any {
    return {
      node: req.node,
      is_continuous: req.is_continuous,
    };
  }

  static toOutputDTO(res: any): DistributeDef {
    return res;
  }
}
